"use strict";

require('./CompanyShareLinksService.js');

var LIMIT = 20;

CompanyShareLinksCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'config',
  'growl',
  'translations',
  'currentUser',
  'shareLinks'];
function CompanyShareLinksCtrl(
  $scope,
  $state,
  $stateParams,
  config,
  growl,
  translations,
  currentUser,
  shareLinks) {
  $scope.shareLinks= shareLinks;
  $scope.currentUser = currentUser;
  $scope.shareURLBase  = config.shareURLBase;
  $scope.apiBase  = config.apiBase;
  $scope.page = $stateParams.page|0;
  if ($scope.shareLinks.length === (LIMIT + 1)) {
    $scope.more = true;
    $scope.shareLinks.pop();
  }
  $scope.filter = {
    q: ($stateParams.filter || ""),
    active: ($stateParams.active === 'true' ? true : ($stateParams.active === 'false' ? false : null))
  };

  $scope.copySuccess = function() {
    growl.addSuccessMessage(translations['publication.share.share-link-copy-success']);
  };

  $scope.copyFail = function() {
    growl.addErrorMessage(translations['publication.share.share-link-copy-failure']);
  };

  $scope.searchShareLinks = function(filter){
    $state.go('root.company.comments.share-links', {filter: filter.q, active: filter.active});
  };
}

CompanyShareLinksCtrl.resolve = {
  shareLinks: ['$stateParams', 'CompanyShareLinksService', function($stateParams, CompanyShareLinksService) {
    return CompanyShareLinksService.query({
  		companyId: $stateParams.companyId,
      q: $stateParams.filter||null,
      active: $stateParams.active||null,
      limit: (LIMIT + 1),
      offset: ($stateParams.page|0) * LIMIT}).$promise;
  }],
  translations: ["$translate", function($translate){
    return $translate([
      'publication.share.share-link-copy-success',
      'publication.share.share-link-copy-failure'
    ]);
  }]
};

module.exports = CompanyShareLinksCtrl;

angular.module("dokiv")
  .controller("CompanyShareLinksCtrl", CompanyShareLinksCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyShareLinksCtrl.js
// module id = 326
// module chunks = 0